import { gql } from "apollo-boost"

export default gql`
  query User($id: ID!) {
    user(id: $id) {
      name
      email
      company {
        name
      }
      title
      dept
    }
  }
`
